/**
 * References:
 *    https://kris101.medium.com/how-to-set-up-file-upload-with-react-and-node-32972dec90d0
 *    https://medium.com/@stephenjwatkins/from-the-browser-to-s3-1798c13d1ee3
 *    https://javascript.info/blob
 *    https://www.thisdot.co/blog/getting-authenticated-images-in-angular/
 *    https://blog.brecht.io/safe-image-requests-in-angular/
 *    https://gaurav5430.medium.com/web-security-images-behind-auth-bb0b955c4770npm 
 */

import React from 'react';
import { useForm, FieldValues } from 'react-hook-form';
import { Document, Page, PDFViewer } from '@react-pdf/renderer';

import axios, { AxiosError } from 'axios';

import ImageFromAzureWithOptions from '../atoms/ImageFromAzureWithOptions';
import ImageFromAzureWithUri from '../atoms/ImageFromAzureWithUri';
import PdfImageFromAzureWithOptions from '../atoms/PdfImageFromAzureWithOptions';
import StandardPage from '../templates/StandardPage';

const TestAzureStorage = (): JSX.Element => {
  const {
    handleSubmit,
    register,
  } = useForm();

  function handleUpload (formData: FieldValues) {
    const files: FileList = formData.files;
    if (files.length) {
      const data = new FormData();
      const file: File = files[0];
      data.append('file', file);
      data.append('folderPath', 'logos/');
      axios
        .post('/upload_file/', data, {
          headers: {
            'Content-Type': file.type,
          }
        })
        .catch((err: AxiosError) => {
          console.error(err);
        })
        .then(() => {
          // TODO: Handle success state
        });
    }
  }

  return (
    <StandardPage>
      <h1 className="f-serif f-normal f-italic" style={{ 'fontSize': '5rem' }}>Test Azure Storage</h1>
      {/* Upload */}
      <h2>Upload Logo</h2>
      <form onSubmit={handleSubmit(handleUpload)}>
        <label>
          Choose file to upload
          <input type="file" accept="image/png, image/jpeg, image/jpg" {...register('files')} />
        </label>
        <button type="submit" className="inline-block ml-2" >Upload Logo</button>
      </form>
      {/* Load from Azure Storage */}
      <h2>Display Logo</h2>
      <h3>Display old logo (should be Microsoft) </h3>
      <img alt="Test <img/> with Azure Storage URI." src="https://lbwdevelopmentcssa01.blob.core.windows.net/radian/assets/pdf_graphics/1_template_bg_full_bleed.png" />
      <ImageFromAzureWithUri alt="Test File Uri Logo" fileUri="https://lbwdevelopmentcssa01.blob.core.windows.net/radian/assets/pdf_graphics/1_template_bg_full_bleed.png" />
      <ImageFromAzureWithOptions fileName="logo.jpg" folderPath="logos/" container="radian" alt="Microsoft Logo" />
      <ImageFromAzureWithOptions fileName="lightbeam-logo.png" folderPath="logos/" container="radian" alt="Lightbeam Logo" />
      <h3>Display uploaded logo on demand</h3>
      <button type="button" className="inline-block ml-2">Display Last Logo</button>
      {/* Grab colors from Canvas via colorthief */}
      <h2>Generate Color Palette</h2>
      <button type="button">Generate Palette</button>
      {/* Embed image in PDF */}
      <h2>Embed Image in PDF</h2>
      <PDFViewer>
        <Document>
          <Page>
            <PdfImageFromAzureWithOptions fileName="lightbeam-logo.png" folderPath="logos/" container="radian" />
          </Page>
        </Document>
      </PDFViewer>
      {/* Upload PDF */}
      <h2>Upload PDF to Azure Storage</h2>
      <button type="button">Upload PDF</button>
      {/* Access PDF from Azure Storage */}
      <h2>Diplay PDF in Azure Storage</h2>
      <button type="button">Display PDF</button>
    </StandardPage>
  );
};

export default TestAzureStorage;
